import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import WindowedSelect from 'react-windowed-select';
import RecurringAvailabilityEditModal from '../../../../components/RecurringAvailabilityEditModal';
import RecurringAvailabilitiesList from './RecurringAvailabilitiesList';
import * as adminApi from '../../../../services/api/admin';
import { fetchAllProvidersBasicInfo } from '../../../../services/api';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';

function RecurringAvailability(props) {
  const { enqueueSnackbar, classes } = props;
  const [recurringAvails, setAvails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [allProviders, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const allProvidersBasicInfo = await fetchAllProvidersBasicInfo();
        const providerList = allProvidersBasicInfo.map(p => ({
          label: p.fullTitle,
          value: p,
        }));
        setProviders(providerList);
        await fetchRecurringAvailabilities();
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        enqueueSnackbar('Error. Please refresh the page to try again.');
      }
    })();
  }, [selectedProvider]);

  const fetchRecurringAvailabilities = async () => {
    let recurringAvailabilities = [];
    if (selectedProvider) {
      recurringAvailabilities = await adminApi.fetchRecurringAvailabiltyByProviderId(
        selectedProvider.value.id
      );
    } else {
      recurringAvailabilities = await adminApi.fetchRecurringAvailability();
    }
    setAvails(recurringAvailabilities);
  };

  const onNew = () => {
    setOpenModal(true);
  };

  const onSave = async recurringAvail => {
    try {
      await adminApi.createRecurringAvailability(recurringAvail);
      enqueueSnackbar('Recurring availability created!', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
      onClose();
      await fetchRecurringAvailabilities();
    } catch (err) {
      console.log(err);
      enqueueSnackbar('Error. Please try again.');
    }
  };

  const onDelete = async recurringAvail => {
    try {
      const confirmed = window.confirm(
        'Deleting will delete all created schedules, are you sure?'
      );
      if (confirmed) {
        await adminApi.deleteRecurringAvailability(recurringAvail);
        enqueueSnackbar('Recurring availability deleted!', {
          preventDuplicate: true,
          autoHideDuration: 3000,
        });
      }
      await fetchRecurringAvailabilities();
    } catch (err) {
      console.log(err);
      enqueueSnackbar('Error. Please try again.');
    }
  };

  const onClose = () => {
    setOpenModal(false);
  };

  return (
    <>
    <div style={{overflow:"scroll"}}>
      <div className={classes.buttonsContainer}>
        <WindowedSelect
          fullWidth
          isSearchable
          isClearable
          aria-label="Search for a provider..."
          placeholder="Search for a provider..."
          value={selectedProvider}
          onChange={setSelectedProvider}
          options={allProviders}
          styles={{
            menu: base => ({
              ...base,
              zIndex: '999',
            }),
            menuList: base => ({
              ...base,
              zIndex: '999',
            }),
          }}
          className={classes.providerFilter}
        />
        <Button
          color="primary"
          variant="contained"
          onClick={onNew}
          className={classes.addButton}
        >
          + Add Availability
        </Button>
      </div>
      <RecurringAvailabilitiesList
        isLoading={isLoading}
        recurringAvails={recurringAvails}
        onDelete={onDelete}
        classes={classes}
      />
      <Grid
        container
        justifyContent="flex-end"
        classes={{ container: classes.actions }}
      />
      </div>

      {openModal && (
        <RecurringAvailabilityEditModal
          open={openModal}
          save={onSave}
          onClose={onClose}
        />
      )}
    </>
  );
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actions: {
    marginTop: '2em',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '40px',
    '@media (max-width: 907px)':{
      flexDirection: 'column',
      gap: "10px",
      justifyContent: "center"
    }
  },
  addButton: {
    width: '250px',
    height: 'auto',
    marginLeft: '5%',
  },
  providerFilter: {
    width: '70%',
  },
});

export default withSnackbar(withStyles(styles)(RecurringAvailability));
